import { render } from "./BasePopover.vue?vue&type=template&id=22ad8584&ts=true"
import script from "./BasePopover.vue?vue&type=script&lang=ts"
export * from "./BasePopover.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__